import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, STATE_STATUS } from '@awp/constants';

const initialState = {
  eetRegions: [],
  eetRegion: null,
  status: STATE_STATUS.IDLE,
  error: null,
};

export const selectAllEetRegions = (state) => state.geoRegions.eetRegions;
export const currentEetRegion = (state) => selectAllEetRegions(state).find((rg) => rg.Id == currentEetRegionId(state));
export const currentEetRegionId = (state) => Number.parseInt(state.geoRegions.eetRegion, 10);
export const getEetRegionLoadingStatus = (state) => state.geoRegions.status;

export const fetchEetRegions = createAsyncThunk(
  'geoRegions/fetchEetRegions',
  async () => {
    const url = REST_API.EET_REGIONS;
    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { geoRegions: state } = getState();
      //Load regions are not loaded
      return state.status !== STATE_STATUS.LOADING;
    },
  },
);

export const geographicAreaSlice = createSlice({
  name: 'geoRegions',
  initialState,
  reducers: {
    setEetRegion(state, action) {
      return { ...state, eetRegion: action.payload };
    },
  },
  extraReducers: {
    [fetchEetRegions.pending]: (state) => {
      state.status = STATE_STATUS.LOADING;
    },
    [fetchEetRegions.fulfilled]: (state, action) => {
      state.status = STATE_STATUS.SUCCESS;
      state.eetRegions = action.payload;
    },
    [fetchEetRegions.rejected]: (state, action) => {
      state.status = STATE_STATUS.FAILED;
      state.error = action.error.message;
    },
  },
});
export const { setEetRegion } = geographicAreaSlice.actions;
